import React from 'react';
import { SimpleBlock, Text } from 'ui-builder';
import styles from './DependentTasksSummary.module.scss';

export interface DependentTasksSummaryProps {
  count: number;
  isCollapsed: boolean;
  onToggle: () => void;
}

export function DependentTasksSummary(props: DependentTasksSummaryProps) {
  const taskWord = props.count === 1 ? 'Dependent Task' : 'Dependent Tasks';

  const getText = () => {
    if (props.isCollapsed) {
      return `▸ ${props.count} ${taskWord}`;
    }
    return `▾ Hide ${taskWord}`;
  };

  return (
    <SimpleBlock
      className={styles.dependentTasksSummary}
      onClick={props.onToggle}
      testID="dependent-tasks-summary"
    >
      <Text>
        {getText()}
      </Text>
    </SimpleBlock>
  );
}
